<template>
  <a-button class="screeningCriteria"
            @click="onMoreFilter">
    {{text}}
    <a-icon v-if="!isMoreFilter"
            type="double-right"
            :style="{ transform: 'rotate(90deg)' }" />
    <a-icon v-if="isMoreFilter"
            type="double-right"
            :style="{ transform: 'rotate(-90deg)' }" />
  </a-button>
</template>
<script>
export default {
  data(){
    return {

    }
  },
  props:{
    isMoreFilter:{
      type:Boolean,
    },
    text:{
      type:String,
      default:'更多查询'
    }
  },
  methods:{
    onMoreFilter(){
      this.$emit('onMoreFilter')
    }
  }
}
</script>
<style scoped lang="less">

.screeningCriteria {
  position: absolute;
  bottom: 0px;
  left: 50%;
  margin-bottom: -14px;
  margin-left: -54px;
  border: none;
}
</style>